import {makeAutoObservable, observable} from 'mobx'
import platform from 'platform'
import {Util} from 'yougile-util'
import {Backend} from '@common/backend'
import {showAlert} from '@components/common/base/notifications'
import {createUseStore} from '@containers/hooks'

type OSType = 'win32' | 'win64' | 'linux' | 'mac'

interface State {
  showOthers: boolean
}

export class DownloadAppStore {
  state: State = {
    showOthers: false
  }

  constructor() {
    makeAutoObservable(this, {
      state: observable.shallow
    })
  }

  setShowOthers(showOthers: boolean) {
    this.state.showOthers = showOthers
  }

  download(osType: 'auto' | OSType) {
    if (osType === 'auto') {
      const family = platform.os.family.toLowerCase()
      if (family.includes('mac') || family.includes('os x')) {
        osType = 'mac'
      } else if (family.includes('linux')) {
        osType = 'linux'
      } else {
        osType = platform.os.architecture + '' === '32' ? 'win32' : 'win64'
      }
    }

    const distUrl = 'https://dist.yougile.com/app'
    if (Util.isDesktop()) {
      void Backend.requestRawJSON({
        url: `${distUrl}/latest.json`,
        method: 'GET'
      }).then((data: any) => {
        if (data && 'version' in data) {
          const {version} = data
          const files: {[type: string]: string} = {
            win32: `YouGile-Setup-${version}-ia32.exe`,
            win64: `YouGile-Setup-${version}-x64.exe`,
            mac: `YouGile-${version}.dmg`,
            linux: `YouGile-${version}-x86_64.AppImage`
          }
          const dl = window.open(`${distUrl}/${files[osType]}`)
          setTimeout(() => dl.close(), 1000)
        } else {
          void showAlert(
            'Failed to load latest version. PLease try again later.'
          )
        }
      })
    } else {
      const dl = window.open('', '_blank')
      void Backend.requestRawJSON({
        url: `${distUrl}/latest.json`,
        method: 'GET'
      }).then((data: any) => {
        if (data && 'version' in data) {
          const {version} = data
          const files: {[type: string]: string} = {
            win32: `YouGile-Setup-${version}-ia32.exe`,
            win64: `YouGile-Setup-${version}-x64.exe`,
            mac: `YouGile-${version}.dmg`,
            linux: `YouGile-${version}-x86_64.AppImage`
          }
          dl.location.href = `${distUrl}/${files[osType]}`
          setTimeout(() => dl.close(), 1000)
        } else {
          void showAlert(
            'Failed to load latest version. PLease try again later.'
          )
          dl.close()
        }
      })
    }
  }
}

const [DownloadAppContext, useDownloadAppStore] =
  createUseStore(DownloadAppStore)
export {DownloadAppContext, useDownloadAppStore}
